module.exports = __webpack_public_path__ + "static/media/isimulate.5ea09b8e.png";